export const makeId = (prefix?: string) => `${prefix ? `${prefix}-` : ''}${Math.random()
  .toString(36)
  .substring(2, 9)}`
